import { render } from "./Admin-Parametre.vue?vue&type=template&id=314a4fe0&scoped=true"
import script from "./Admin-Parametre.vue?vue&type=script&lang=js"
export * from "./Admin-Parametre.vue?vue&type=script&lang=js"

import "./Admin-Parametre.vue?vue&type=style&index=0&id=314a4fe0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-314a4fe0"]])

export default __exports__